// Jednotný formát telefónu v celom Matrixe (Mirko 22.7.): vstup ľubovoľný → "+421 9XX XXX XXX".
// SK: 0918443675 / +421918443675 / 0918 443 675 → "+421 918 443 675". Iné krajiny ostávajú v +číslo tvare.
export function normPhone(raw) {
  let d = String(raw || '').trim().replace(/[^\d+]/g, '')
  if (!d) return ''
  if (d.startsWith('00')) d = '+' + d.slice(2)
  if (d.startsWith('+421') === false && d.startsWith('0')) d = '+421' + d.slice(1)
  if (!d.startsWith('+')) d = (d.length === 9 ? '+421' + d : '+' + d)
  const m = d.match(/^\+421(\d{3})(\d{3})(\d{3})$/)
  return m ? '+421 ' + m[1] + ' ' + m[2] + ' ' + m[3] : d
}
// holé číslo pre SMS bránu / tel: odkaz (bez medzier)
export const phoneDigits = (raw) => normPhone(raw).replace(/\s/g, '')
